import type { ChangeEvent } from "react";
import type { FieldPath, FieldPathValue, FieldValues } from "react-hook-form";

import {
  BaseTextFieldElement,
  type BaseTextFieldElementProps,
} from "./base/BaseTextFieldElement";

export type TextFieldElementProps<
  FormValues extends FieldValues,
  FieldName extends FieldPath<FormValues> = FieldPath<FormValues>,
> = Omit<
  BaseTextFieldElementProps<FormValues, FieldName>,
  "getValueFromEvent" | "isValueChangeCancelled"
> & {
  characterRegExpFilter?: RegExp;
};

export const TextFieldElement = <
  FormValues extends FieldValues,
  FieldName extends FieldPath<FormValues> = FieldPath<FormValues>,
>({
  characterRegExpFilter,
  ...baseTextFieldElementProps
}: TextFieldElementProps<FormValues, FieldName>) => {
  return (
    <BaseTextFieldElement<FormValues, FieldName>
      {...baseTextFieldElementProps}
      getValueFromEvent={(event: ChangeEvent<HTMLInputElement>) =>
        event.target.value as FieldPathValue<FormValues, FieldName>
      }
      isValueChangeCancelled={(
        value: FieldPathValue<FormValues, FieldName> | null,
      ) =>
        value !== "" && characterRegExpFilter !== undefined
          ? !characterRegExpFilter.test(value as string)
          : false
      }
      type="text"
    />
  );
};
